import { get } from './utils';

/**
 * Get all active currencies that are currently enabled on the skin
 * @param {string} playerSessionID
 */
export var getCurrencies = function getCurrencies() {
  return get('/currencies');
};

/**
 * Get all active display currencies that are currently enabled on the skin
 * @param {string} playerSessionID
 */
export var getDisplayCurrencies = function getDisplayCurrencies() {
  return get('/currencies/display');
};

export default {
  getCurrencies: getCurrencies,
  getDisplayCurrencies: getDisplayCurrencies
};